import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { ButtonVariantType } from "../../../Common/UI/Types";
import { Button } from "../../../Common/UI/Index";
import Add from "~icons/ic/baseline-add-circle";
import Refresh from "~icons/ic/outline-refresh";
import "./Style.scss";

interface CreateVersionButtonProps {
  /**
   * Handler for onclick
   */
  onClick: () => void;
  /**
   * Handler for refresh button
   */
  onRefreshClick: () => void;
  /**
   * Flag to show refresh button
   */
  toShowRefresh: boolean;
}

/**
 * Responsible for rendering the create version button view
 */
export const CreateVersionButtonView: React.FC<CreateVersionButtonProps> = (props: CreateVersionButtonProps) => {
  const { onClick, onRefreshClick, toShowRefresh } = props;
  const { t: translate } = useTranslation();

  return (
    <div className="ebt-extract-versioning__add-btn">
      <Button
        className="ebt-extract-versioning__add-btn--add"
        data-testid="ebt-create-new-version"
        variant={ButtonVariantType.FILLED}
        onClick={onClick}
      >
        <Add title="add" />
        {translate("Button.CreateNewVersion")}
      </Button>
      {toShowRefresh &&
        <Button
          data-testid="ebt-refresh-version"
          borderless={true}
          onClick={onRefreshClick}
        >
          <Refresh title="refresh" />
          {translate("Button.RefreshVersion")}
        </Button>
      }
    </div>
  );
};
